import Dropcursor from '@tiptap/extension-dropcursor';
import Typography from '@tiptap/extension-typography';

/**
 * Shared Typography extension configuration.
 * Disables most automatic text replacements except for arrow symbols.
 * Used across vMarkdown and vJSON editors for consistent behavior.
 */
export const configuredTypography = Typography.configure({
  closeDoubleQuote: false,
  closeSingleQuote: false,
  copyright: false,
  ellipsis: false,
  emDash: false,
  laquo: false,
  leftArrow: '←',
  multiplication: false,
  notEqual: false,
  oneHalf: false,
  oneQuarter: false,
  openDoubleQuote: false,
  openSingleQuote: false,
  plusMinus: false,
  raquo: false,
  registeredTrademark: false,
  rightArrow: '→',
  servicemark: false,
  superscriptThree: false,
  superscriptTwo: false,
  threeQuarters: false,
  trademark: false,
});

/**
 * Shared Dropcursor extension configuration.
 * Used across vMarkdown and vJSON editors for consistent drag-and-drop behavior.
 */
export const configuredDropcursor = Dropcursor.configure({
  width: 2,
  class: 'ProseMirror-dropcursor',
  color: '#7dd3fc',
});
